import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgDictionaryIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M6.667 16H20v4.971S7.53 21 6.667 21a2.505 2.505 0 1 1 0-5ZM8 18.5h8"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 18V3h16v15"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m9 12 3-5 3 5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.75 10.571h4.5" stroke="currentColor" strokeWidth={1.5} />
  </svg>
);

const ForwardRef = forwardRef(SvgDictionaryIcon);
const Memo = memo(ForwardRef);
export default Memo;
